var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.buttonsArray),function(button){return _c('div',{key:button.label,staticClass:"w-full text-white mt-8 p-2 bg-neutral-600 hover:bg-neutral-700 cursor-pointer",on:{"click":function($event){_vm.$emit('hide') && _vm.routeTo(_vm.$router,button.path)}}},[_vm._v(" "+_vm._s(button.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }